import { FC, useContext } from 'react';
import { EditorRequestedProjects } from 'modules/dashboard/ProjectsTableConfig';
import Styles from '../../unassigned-projects/unassigned-projects.module.scss';
import { prettifyDate } from 'utils';
import { Stack } from 'modules/common/components/Stack/Stack';
import { Button } from 'modules/common/components/Button/Button';
import { Card } from 'modules/common/components/Card/Card';
import { useAcceptBookForProofingMutation } from 'redux/api/app.api';
import { RequestProjectStatus } from 'modules/common/types';
import useModal from 'modules/common/hooks/useModal';
import { SomethingWentWrong } from 'modules/common/components/Notify';
import { Icon } from 'icons';
import { Link } from 'react-router-dom';
import { useUserId } from 'modules/common/hooks/useUserId';

interface Props {
  project: EditorRequestedProjects;
  isFetching?: boolean;
}

const ProjectItem: FC<Props> = ({ project, isFetching }) => {
  const [acceptBookForProofing, { isLoading }] = useAcceptBookForProofingMutation();
  const userId = useUserId();
  if (!userId) return null;

  return (
    <>
      <Card className={Styles.card}>
        <Stack
          direction="column"
          justifyContent="space-between"
          className="h-100"
        >
          <Stack.Item>
            <p className="fw-500 font-size-xs m-b-1-5">
              {prettifyDate(project.dateAdded)}
            </p>
          </Stack.Item>
          <Stack.Item>
            <p className="m-b-half">
              {project.author} uploaded project ( {project.name} )
            </p>
            <Stack justifyContent="space-between" spacing={2} className="m-t-3">
              <Stack.Item>
                <Button
                  disabled={isLoading || isFetching}
                  onClick={() =>
                    acceptBookForProofing({
                      prooferId: userId,
                      projectId: project.id,
                    })
                  }
                >
                  Accept Project for Proofing
                </Button>
              </Stack.Item>
              <Stack.Item>
                <Button secondary disabled={isLoading || isFetching}>
                  <Link to={`/editor/${project.id}`} className="h-100 w-100">
                    <Icon name="remove_red_eye" />
                  </Link>
                </Button>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        </Stack>
      </Card>
    </>
  );
};

export default ProjectItem;
